import Vue from 'vue'
import {store} from '../store.js'
import mixins from '@/mixins.js'


const state = {
    layout: 'Loading',
    fullScreenLoading: false,
    pill: {
        visible: false,
        status: '',
        message: ''
    },

    peopleLabels: [
        {
            id: 1,
            title: 'Adults',
            text: '16+',
            field: 'adl',
        },
        {
            id: 2,
            title: 'Children',
            text: '3-16',
            field: 'chl'
        },
        {
            id: 3,
            title: 'Infants',
            text: 'under 3',
            field: 'inf'
        },
        {
            id: 4,
            title: 'Seniors',
            text: '65+',
            field: 'snr',
        }
    ],

    eventsRangeDays: 10,

    countries: [],
    currencies: [],
    languages: [],
    timezones: [],
    eventColors: [],
    percentageOrCurrency:[
        {
            id: 1,
            label: "%",
            bigName: "Percentage"
        },
        {
            id: 0,
            label: "€",
            bigName: "Euro"
        }
    ],
    namePrefixList: [
        {"id":1,"description":"Mr."},
        {"id":2,"description":"Ms."},
        {"id":3,"description":"Mrs."}
    ],
    vatTypes: [
        {"id":0,"description":"No VAT"},
        {"id":6,"description":"VAT 6%"},
        {"id":13,"description":"VAT 13%"},
        {"id":23,"description":"VAT 23%"}
    ],
    paymentDirections: [
        {"id":0,"description":"Pay In"},
        {"id":1,"description":"Pay Out"}
    ],
    paymentTypeListAll: [
        {"icon":"far fa-money-bill-alt","id":1,"description":"Cash"},
        {"icon":"fas fa-credit-card","id":2,"description":"Debit Card"},
        {"icon":"far fa-credit-card","id":3,"description":"Credit Card"},
        {"icon":"fab fa-paypal","id":5,"description":"PayPal"},
        {"icon":"fas fa-university","id":6,"description":"Bank Transfer"},
        {"icon":"fas fa-users","id":-100,"description":"Agent Deposit"},
        {"icon":"fab fa-cc-stripe","id":-90,"description":"Stripe"},
        {"img": require('@/assets/images/paymentMehtods/Logo_Redunicre.png'),"id":7,"description":"Redunicre"},
    ],
    slimFilters: null,
    reservationStates:[ // old - this should be deprecated in favor of allReservationStates
        {
            description: "Booked",
            id: 1
        },
        {
            description: "Rebooked",
            id: 30
        },
        {
            description: "Canceled",
            id: -5
        },
        {
            description: "Pending",
            id: 5
        },
    ],
    allReservationStates:[
        {
            code: "1",
            label:"Booked",
            color: 'color-3',
            cssClass: 'dark border-dark',
            allowChange: true,
            isOption: true,
        },
        {
            code: "5",
            label:"Pending",
            color: 'color-1',
            cssClass: 'bg-color-1',
            allowChange: true,
            isOption: true,
        },
        {
            code: "-100",
            label:"Stripe Error",
            color: 'color-6',
            cssClass: 'bg-color-6',
            allowChange: false,
            isOption: false,
            // onSelect: this.setReservationToCancel
        },
        {
            code: "-5",
            label:"Canceled",
            color: 'dark',
            cssClass: 'bg-dark',
            allowChange: true,
            isOption: true,
            // onSelect: this.setReservationToCancel
        },
        {
            code: "20",
            label:"Rebooked",
            color: 'color-2',
            cssClass: 'bg-color-2',
            extraLabel: function (reservation, formatTicketNumber) {
                // TODO: Improve to use "formatTicketNumber" independently
                return 'to '+formatTicketNumber(reservation.childBookingId);
            },
            clickAction: () => {
                store.dispatch('closeModal')
                store.dispatch('openReservationById', store.getters.getSelectedReservation.childBookingId)
            }
        },
        {
            code: "21",
            label:"Rebooked",
            color: 'color-2',
            cssClass: 'bg-color-2',
            extraLabel: function (reservation, formatTicketNumber) {
                // TODO: Improve to use "formatTicketNumber" independently
                return 'to '+formatTicketNumber(reservation.childBookingId);
            },
            clickAction: () => {
                store.dispatch('closeModal')
                store.dispatch('openReservationById', store.getters.getSelectedReservation.childBookingId)
            }
        },
        {
            code: "30",
            label:"Rebooked",
            color: 'color-2',
            cssClass: 'bg-color-2',
            extraLabel: function (reservation, formatTicketNumber) {
                // TODO: Improve to use "formatTicketNumber" independently
                return 'from '+formatTicketNumber(reservation.parentBookingId);
            },
            clickAction: () => {
                store.dispatch('closeModal')
                store.dispatch('openReservationById', store.getters.getSelectedReservation.parentBookingId)
            }

        },
        {
            code: "50",
            label:"PreBooked",
            color: 'dark',
            cssClass: 'bg-dark',
        },
        {
            code: "-50",
            label:"PreBookCanceled",
            color: 'dark',
            cssClass: 'bg-dark',
        },
        {
            code: "-6",
            label:"Pending Cancelation",
            color: 'dark',
            cssClass: 'bg-dark',
            allowChange: true,
        },
    ],


    // ********* Settings - Accounts *********
    isLoadingSupplierAccounts: false,
    supplierAccounts: null,
    virginSupplierAccount: {
        by: null,
        id: null,
        name: null,
        nickname: null,
        email: null,
        position: null,
        isActive: true,
        phoneNumber: null,
        imagePhoto: null,
        imagePhotoBase64: null,
        userAccountTypeDefault: {
            accessType: 0, //0 basic | 1 Admin
            accountType: 0,
            agent: null,
            agentId: null,
            isDefault: false,
            parentId: 0,
            supplier: null,
            supplierId: null,
        },
        userAccountTypes: [
            {
                accessType: 0, //0 basic | 1 Admin
                accountType: 0,
                agent: null,
                agentId: null,
                isDefault: false,
                parentId: 0,
                supplier: null,
                supplierId: null,
            }
        ]
    },
    selectedSupplierAccount: null,
    channelSalesList: [
        {
            "id": 200,
            "description": "Hotel/Concierge"
        },
        {
            "id": 201,
            "description": "Ticketshop"
        },
        {
            "id": 202,
            "description": "Tour Operator"
        },
        {
            "id": 203,
            "description": "Online Travel Agency"
        },
        {
            "id": 204,
            "description": "Online Activities Website"
        },
        {
            "id": 205,
            "description": "Local Host"
        },
        {
            "id": 206,
            "description": "Activities Supplier"
        },
        {
            "id": 207,
            "description": "Visitor Information Center"
        },
        {
            "id": 100,
            "description": "Others"
        },
    ],
    audienceTypeList: []
};

const getters = {
    layout: (state) => state.layout,
    getFullScreenLoading: (state) => state.fullScreenLoading,
    getSlimFilters: (state) => state.slimFilters,
    getCountries: state => state.countries,
    getLanguages: (state) => state.languages,
    getTimezones: (state) => state.timezones,
    getCurrencies: (state) => state.currencies,
    getPill: (state) => state.pill,
    getPeopleLabels: (state) => state.peopleLabels,
    getEventsRangeDays: (state) => state.eventsRangeDays,
    getEventColors: (state) => state.eventColors,
    getPaymentDirections: (state) => state.paymentDirections,
    getReservionStates: (state) => state.reservationStates,
    getAllReservationStates: (state) => state.allReservationStates,
    getReservationState: (state, getters) => (code) => {
        let foundState = getters.getAllReservationStates.find(state => state.code == code)
        return foundState? foundState : 'n'
    },
    getPercentageOrCurrency: (state) => state.percentageOrCurrency,

    // ********* Settings - Accounts *********
    getIsLoadingSupplierAccounts: (state) => state.isLoadingSupplierAccounts,
    getSupplierAccounts: (state) => state.supplierAccounts,
    getSupplierAccountVirgin: (state, rootState) => {
        let virginAccount = JSON.parse(JSON.stringify(state.virginSupplierAccount))
        virginAccount.salesChannel = rootState.getSalesChannels.filter(sc => { return sc.channelType == 0})[0]
        return virginAccount
    },
    getSelectedSupplierAccount: (state) => state.selectedSupplierAccount,
    getPaymentTypeListAll: (state) => state.paymentTypeListAll,
    getNamePrefixList: (state) => state.namePrefixList,
    getVatTypes: (state) => state.vatTypes,
    getChannelSalesList: (state) => state.channelSalesList,
    getAudienceTypeList: (state) => state.audienceTypeList,
};

const actions = {
    switchLayout: ({ commit }, layout) => {
        commit('SWITCH_LAYOUT', layout ? layout : 'pluralo');
    },

    startFullScreenLoading: ({state}) => {
        state.fullScreenLoading = true
    },

    stopFullScreenLoading: ({state}) => {
        state.fullScreenLoading = false
    },

    downloadSlimFilters: ({commit, rootState}) => {
        // if(!rootState.user.account.supplierId){
        //     return false
        // }
        return axios.get('/api/Calendar/GetFilters',{
            params: {
                supplierId: rootState.user.account.supplierId
            }
        }).then(response => {
            if(response.status && response.status == 200){
                commit('SET_FILTERS_OBJ', response.data);
            }
            return response
        }).catch( error => {
            console.error(error);
        })
    },

    search: ({ state, rootState, dispatch, commit, getters }, data) => {

    },

    showPill: ({ commit, dispatch }, data) => {
        commit('SHOW_PILL', data);

        //setTimeout(() => { dispatch.hidePill }, 4000);
    },

    hidePill: ({ commit }) => {
        commit('HIDE_PILL');
    },


    // Sends a message and updates the 'to' user with it.
    // Currently sending everything to 'myself' to test things

    sendMessage: ({ commit, rootState }, message) => {
        console.log(message, ' sent');
    },

    // Updates the current list narrowing it down by advanced
    // search filters

    updateSearchFilters: ({ commit }, data) => {
        // The database table holding the list of items (eg. reservations)
        var table = data.table;

        // The filters (eg. filtering by agent)
        var filters = data.filters

        // TODO
        console.log('filtering on ', table, ' table ...');

        commit('UPDATE_SEARCH_FILTERS', data);
    },

    initGeography: ({ commit }) => {
        let data = {};

        return axios.all([
            axios.get('api/country/list'),
            axios.get('api/settings/GetLanguages'),
            axios.get('api/settings/GetTimeZones'),
            axios.get('api/settings/GetCurrencies'),
        ])
        .then(axios.spread(function(countries, languages, timezones, currencies) {
            data.countries = (countries.status === 200) ? countries.data : null;
            data.languages = (languages.status === 200) ? languages.data : null;
            data.timezones = (timezones.status === 200) ? timezones.data : null;
            data.currencies = (currencies.status === 200) ? currencies.data : null;
            return true // just to make the promise work
        }))
        .then(function (response) {
            commit('INIT_GEOGRAPHY', data);
            return true // just to make the promise work
        })
        .catch(error => {
            Vue.toasted.error(error.response.data.message);
            return true // just to make the promise work
        });
    },

    // Removes an item.
    // Example:
    // this.removeItem({
    //     table: 'agents',
    //     object: 'agent',
    //     module: 'inventory',
    //     fields: { supplierId: rootState.user.account.supplierId, Agent: item }
    // });

    removeItem: ({ commit, dispatch }, data) => {
        if (!data.object || !data.table) {
            throw new Error('Invalid object or table on removeItem');
        }

        let object = data.object.charAt(0).toUpperCase() + data.object.slice(1);
        let ucTable = data.table.charAt(0).toUpperCase() + data.table.slice(1);

        return Vue.dialog.confirm('Delete this '+data.object+'?', {okText: 'Yes', cancelText: 'No'}).then(function () {

            // proceed with delete
            return axios.post('/api/' + data.module + '/Delete' + object, data.fields).then((response) => {
                if (response && response.status === 200) {
                    dispatch('init' + ucTable);
                    dispatch('clearSelectedItem');
                    dispatch('closeModal');

                    Vue.toasted.success(response.data.message);
                }
                return response
            })
            .catch(function(error) {
                //Vue.toasted.error(error);
                return error
            });

        }).catch(function (error) {
            return error
        });


    },



    downloadEventColors: ({commit, rootState}, data) => {
            return axios.get('/api/settings/GetProductColors', {
                params: {
                    supplierId: rootState.user.account.supplierId
                }
            }).then((response) => {
                if (response && response.status === 200 && response.data && response.data.length > 0) {
                    state.eventColors = response.data;
                    commit('UPDATE_EVENT_COLORS', response.data);
                    return response.data
                }
            }).catch(err => {
                return err
            })
    },

    // payment / billing stuff

    createLocation: ({ commit, rootState }, payload) => {
        return axios.post('/api/supplier/createlocation', {
            supplierId: rootState.user.account.supplierId,
            location: payload
        })
    },

    editLocation: ({commit, rootState}, payload) => {
        return axios.post('/api/supplier/editlocation', {
            supplierId: rootState.user.account.supplierId,
            location: payload
        })

    },

    deleteLocation: ({commit, rootState}, payload) => {
        return axios.post('/api/supplier/deletelocation', {
            supplierId: rootState.user.account.supplierId,
            location: payload
        })

    },

    createRoute: ({commit, rootState}, payload) => {
        payload.supplierId = rootState.user.account.supplierId
        //set last stop as description
        payload.routeDestination = payload.iteneraries[0]
        return axios.post('/api/booking/CreateRoute', payload).then(response => {
            if(response.status == 200){
                Vue.toasted.success('Route saved with success');
            }
            return response
        }).catch(error => {
            return error
        })

    },

    editRoute: ({commit, rootState}, payload) => {
        payload.supplierId = rootState.user.account.supplierId
        //set last stop as description
        payload.routeDestination = payload.iteneraries[0]

        return axios.post('/api/booking/EditRoute', payload).then(response => {
            if(response.status == 200){
                Vue.toasted.success('Route saved with success');
            }
            return response
        }).catch(error => {
            return error
        })

    },

    deleteRoute: ({commit, rootState}, payload) => {
        return axios.post('/api/booking/DeleteRoute', payload)

    },

    // ***************************************
    // ********* Settings - Accounts *********
    // ***************************************

    downloadSupplierAccounts: ({commit, dispatch, state, rootState}) => {
        state.isLoadingSupplierAccounts = true
        return axios.get('/api/account/supplierList', {
            params: {
                supplierId: rootState.user.account.supplierId,
            }
        }).then(response => {
            state.isLoadingSupplierAccounts = false
            if(response.status == 200){
                commit('SET_SUPPLIER_ACCOUTS', response.data)
                return true
            } else {
                return false
            }
        }).catch(error => {
            state.isLoadingSupplierAccounts = false
        })
    },

    createSupplierAccount: ({commit, dispatch, rootState}, userAccount) => {
        Vue.toasted.info('Creating account');
        return axios.post('/api/Account/SupplierUserAccountCreate', {
            by: rootState.user.account.name,
            supplierId: rootState.user.account.supplierId,
            userAccount: userAccount
        }).then(response => {
            if(response.status == 200){
                Vue.toasted.success('Account successfully created');
                dispatch('downloadSupplierAccounts')
                return true
            } else {
                return false
            }
        })
    },

    editSupplierAccount: ({commit, dispatch, rootState}, userAccount) => {
        Vue.toasted.info('Editing account');
        return axios.post('/api/Account/SupplierUserAccountEdit', {
            by: rootState.user.account.name,
            supplierId: rootState.user.account.supplierId,
            userAccount: userAccount
        }).then(response => {
            if(response.status == 200){
                Vue.toasted.success('Account successfully edited');
                // commit('UPDATE_SINGLE_ACCOUNT', response.data) // - to avoid updating the entire list but its not working because the list component does not auto update
                if(userAccount.userAccountTypeDefault.accountType == 1){
                    dispatch('downloadSupplierAccounts')
                }
            }
            return response
        })
    },

    setStatusSupplierAccount: ({commit, dispatch, rootState}, requestObject) => {
        // requestObjec = {userAccount: userAccount, action: 'activate'}

        let endpoint = null
        let successMessage = null
        if(requestObject.action === 'activate'){
            Vue.toasted.info('Activating account');
            successMessage = 'Account successfully activated'
            endpoint = 'MemberSetActive'
        } else if (requestObject.action === 'disable') {
            Vue.toasted.info('Disabling account');
            successMessage = 'Account successfully disabled'
            endpoint = 'MemberSetInactive'
        } else {
            console.log('setStatusSupplierAccount invalid action');
            return false
        }

        return axios.post('/api/Account/'+endpoint, {
            by: rootState.user.account.name,
            supplierId: rootState.user.account.supplierId,
            userAccount: requestObject.userAccount
        }).then(response => {
            if(response.status == 200){
                Vue.toasted.success(successMessage);
                dispatch('downloadSupplierAccounts')
                return true
            } else {
                return false
            }
        })
    },

    deleteSupplierAccount: ({commit, dispatch, rootState}, userAccount) => {
        Vue.toasted.info('Deleting account');
        return axios.post('/api/Account/SupplierUserAccountDelete', {
            by: rootState.user.account.name,
            supplierId: rootState.user.account.supplierId,
            userAccount: userAccount
        }).then(response => {
            if(response.status == 200){
                Vue.toasted.success('Account successfully deleted');
                dispatch('downloadSupplierAccounts')
                return true
            } else {
                return false
            }
        })
    },

    setSupplierAccountAsSelected: ({commit}, userAccount) => {
        commit('SET_SELECTED_SUPPLIER_ACCOUNT', userAccount)
    },

    clearSelectedSupplierAccount: ({commit}) => {
        commit('SET_SELECTED_SUPPLIER_ACCOUNT', null)
    },

    downloadAudienceTypeList: ({commit}) => {
        return axios.get('/api/settings/GetAudienceTypeList').then(response => {
            commit('SET_AUDIENCE_TYPE_LIST', response.data)
            return response
        }).catch(err => {
            return err
        })
    }

};

const mutations = {
    SWITCH_LAYOUT: (state, layout) => {
        state.layout = layout;
    },

    SET_FILTERS_OBJ: (state, payload) => {
        state.slimFilters = payload;
    },



    PROCESS_SEARCH_RESULTS: (state, rootState, data) => {
        rootState[data.module][data.object] = data.results;
    },

    // Sets up a success/error pill message above the layout

    SHOW_PILL: (state, data) => {
        state.pill.visible = true;
        state.pill.status = data.status;
        state.pill.message = data.message;
    },

    HIDE_PILL: (state) => {
        state.pill.visible = false;
        state.pill.status = '',
        state.pill.message = '';
    },

    UPDATE_SEARCH_FILTERS: (state, data) => {

    },

    // Initializes geographic information

    INIT_GEOGRAPHY: (state, data) => {
        state.countries = data.countries;
        state.timezones = data.timezones;
        state.languages = data.languages;
        state.currencies = data.currencies;
    },



    UPDATE_EVENT_COLORS: (state, payload) => {
        state.eventColors = payload;
    },

    // ********* Settings - Accounts *********

    SET_SUPPLIER_ACCOUTS: (state, payload) => {
        state.supplierAccounts = payload
    },

    SET_SELECTED_SUPPLIER_ACCOUNT: (state, selectedUserAccount) => {
        state.selectedSupplierAccount = selectedUserAccount
    },

    UPDATE_SINGLE_ACCOUNT: (state, userAccount) => {

        for (var i = 0; i < state.supplierAccounts.length; i++) {
            if(state.supplierAccounts[i].id == userAccount.id) {
                state.supplierAccounts[i] = userAccount
            }
        }

    },

    SET_AUDIENCE_TYPE_LIST: (state, payload) => {
        state.audienceTypeList = payload
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js